import { createContext } from 'react';
import { StructMapCtxProps } from './struct-map-types';

export const StructMapCtx = createContext<StructMapCtxProps>(
  {} as StructMapCtxProps
);
